import React from "react";
import Icon from "assets/icons";
import classNames from "classnames";
import Button from "shared/components/button";
import useTableOptionsService from "./service";
import { useCopies } from "shared/hooks/useCopies";
import ColumnSelector from "../Table/columnSelector";
import {
  TableOptionConfig,
  TableOptionFiltersConfig,
  TableOptionScreenNameConfig,
  TableOptionActionItemsConfig
} from "./types";

function TableOptions(props: TableOptionConfig) {
  return (
    <div className={classNames("tableOption", props.className)} ref={props.measurementRef}>
      <ScreenName screenName={props.screenName} />
      <div className="tableOption_actionItems">{props.children}</div>
    </div>
  );
}

export default TableOptions;

function ScreenName(props: TableOptionScreenNameConfig) {
  return (
    <div className="tableOption_screenName">
      <h1 className="tableOption_screenName--title">{props.screenName}</h1>
    </div>
  );
}

export function TableOptionActionItems({
  hasRefreshIcon = true,
  hasFullScreenIcon = true,
  hasManageColumnSelector = true,
  hasSearchIcon = true,
  ...props
}: TableOptionActionItemsConfig) {
  const copies = useCopies();
  const tableOptionsService = useTableOptionsService(props);

  return (
    <div
      ref={tableOptionsService.optionRef}
      className={classNames("tableOption_actionItems_icons", props.className, {
        wrapped: tableOptionsService.wrapped
      })}>
      {props.left && <React.Fragment>{props.left}</React.Fragment>}
      {hasRefreshIcon && (
        <Button
          hasShadow
          icon={<Icon.Refresh />}
          onClick={props.onRefresh}
          className="refreshBtn"
          title={copies.get("refresh")}
        />
      )}
      {hasFullScreenIcon && (
        <Button
          hasShadow
          icon={tableOptionsService.expand ? <Icon.FullScreenExit size={22} /> : <Icon.FullScreen size={22} />}
          onClick={tableOptionsService.expandTable}
          title={tableOptionsService.expand ? copies.get("exit.fullscreen.view") : copies.get("enter.fullscreen.view")}
        />
      )}
      {props.onInfoModalClick && (
        <Button
          hasShadow
          icon={<Icon.InfoIcon size={16} />}
          onClick={props.onInfoModalClick}
          title={copies.get("user.roles")}
        />
      )}
      {props?.tableRef?.current && hasManageColumnSelector && (
        <ColumnSelector tableRef={props.tableRef} hasSearchIcon={hasSearchIcon} />
      )}
      {props.right && <React.Fragment>{props.right}</React.Fragment>}
    </div>
  );
}

export function TableOptionFilters(props: TableOptionFiltersConfig) {
  return <div className={classNames("tableOption_actionItems_filters", props.className)}>{props.children}</div>;
}
